<div class="marker is-flex has-flex-content-center has-flex-align-center has-pos-rel"
     [class.cluster]="marker.isCluster"
     [class.favourite]="marker.isFavourite"
     [class.viewed]="marker.hasBeenViewed">
  <img *ngIf="!marker.isCluster && marker.isFavourite"
       [src]="('/assets/icons/heart/heart_icon_white_full@1x.svg' | staticp)"
       alt="Favourite" />
  <span>
    {{ marker.label }}
  </span>
</div>
